const getPickUnit = (code?: string): 'pieces' | 'kilogram' => {
  const normalized = (code || '').toLowerCase();
  if (normalized === 'st' || normalized === 'pieces') return 'pieces';
  return 'kilogram';
};

export default getPickUnit;
